//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  ISystemAlertsResponse,
  ISystemAlertsResult,
} from '@apis/system-alerts/systemAlertsApiModels';
import { serializedGatewayFetch } from '@utils/sessionFetch';

const SYSTEM_ALERTS_ENDPOINT = '/api/v1/system/alerts';

function systemAlertsGatewayFetch(endpoint: string, init?: RequestInit) {
  return serializedGatewayFetch(
    'web_gateway',
    `${SYSTEM_ALERTS_ENDPOINT}${endpoint}`,
    init,
  );
}

export async function getSystemAlerts(): Promise<ISystemAlertsResult> {
  const res = await systemAlertsGatewayFetch('');
  const response = await res.json<ISystemAlertsResponse>();

  return response.data;
}
